import { createRouter, createWebHistory } from 'vue-router';
import Roster from '../components/Roster.vue';
import CharacterSheet from '../components/CharacterSheet.vue';
import NewCharacter from '../components/NewCharacter.vue';
import CSSkillTree from '@/components/CSSkillTree.vue';
import Stories from '@/components/Stories.vue';
import Story from '@/components/Story.vue';

const routes = [
    { 
        path: '/', 
        name: 'Home', 
        component: Roster 
    },
    {
        path: '/new-character',
        name: 'NewCharacter',
        component: NewCharacter
    },
    { 
        path: '/character/:id', 
        name: 'Character', 
        component: CharacterSheet, 
        props: route => ({ id: Number(route.params.id) })
    },
    { 
        path: '/ability-tree/:id', 
        name: 'Abilities', 
        component: CSSkillTree, 
        props: true 
    },
    {
        path: '/stories',
        name: 'Stories',
        component: Stories
    },
    { 
        path: '/story/:id', 
        name: 'Story', 
        component: Story, 
        props: route => ({ id: Number(route.params.id) }),
    }
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
});
  
export default router;
